import { StarterPromotion2025Banner } from 'pricing-pages-ui-components/banners/StarterPromotion2025Banner';
import Raven from 'raven-js';
import { useEffect } from 'react';
import { useDisplayedCurrencyCode } from '../../hooks/useCurrencies';
import { useStarterPromo2025 } from '../../hooks/useStarterPromo2025';
import { trackBannerInteraction } from '../../v2/utils/tracking/trackingEventUtils';
import { jsx as _jsx } from "react/jsx-runtime";
export const StarterPromotion2025BannerWrapper = ({
  screen
}) => {
  const currencyCode = useDisplayedCurrencyCode();
  const {
    shouldShowBanner,
    error,
    annualPrice,
    monthlyPrice
  } = useStarterPromo2025({
    screen
  });
  useEffect(() => {
    // error covers the case where annual or monthly price is not found
    if (error) {
      Raven.captureException(error);
    }
  }, [error]);
  if (!shouldShowBanner || !annualPrice || !monthlyPrice) {
    return null;
  }
  return /*#__PURE__*/_jsx(StarterPromotion2025Banner, {
    annualPrice: annualPrice,
    monthlyPrice: monthlyPrice,
    currencyCode: currencyCode,
    trackBannerInteraction: trackBannerInteraction
  });
};
export default StarterPromotion2025BannerWrapper;